import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Birth control forms
   */
  {
    // 1
    label: 'Are you currently on birth control?',
    field: 'birthControl',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'list',
            items: [
              {
                label:
                  'What is the name of the birth control you are currently using?',
                type: 'text',
                name: 'birthControlName'
              },
              {
                label:
                  'Is this the birth control that you would like to continue?',
                type: 'radio',
                name: 'birthControlContinue',
                options: [
                  {
                    key: 'know',
                    value: 'I know which brand I want',
                    answer: { type: 'text', name: 'brandDesc' }
                  },
                  { key: 'doctorHelp', value: 'Let the doctor help me chose' }
                ]
              }
            ]
          }
        },
        {
          key: 'no',
          value: 'No',
          answer: {
            label: 'Have you been on birth control in the past?',
            type: 'radio',
            name: 'everBirthControl',
            options: [
              {
                key: 'yes',
                value: 'Yes',
                answer: {
                  type: 'list',
                  items: [
                    {
                      label: 'How long ago?',
                      type: 'dropdown',
                      name: 'agoMonths',
                      placeholder: 'ago',
                      options: [
                        { key: 'less6m', value: 'Less than 6 months ago' },
                        { key: '6to12m', value: '6 to 12 months ago' },
                        { key: '1to5y', value: '1 to 5 years ago' },
                        { key: 'more5y', value: 'More than 5 years ago' }
                      ]
                    },
                    {
                      label:
                        'What was the name of birth control that worked best for you?',
                      type: 'text',
                      name: 'bestBirthControl'
                    },
                    {
                      label:
                        'Is this the birth control that you would like to go back on?',
                      type: 'radio',
                      name: 'likeGoback',
                      options: [
                        {
                          key: 'know',
                          value: 'I know which brand I want',
                          answer: { type: 'text', name: 'goBackBrandDesc' }
                        },
                        {
                          key: 'doctorHelp',
                          value: 'Let the doctor help me chose'
                        }
                      ]
                    }
                  ]
                }
              },
              { key: 'no', value: 'No' }
            ]
          }
        }
      ],
      fullWidth: true
    }
  },
  {
    // 2
    label: 'Have you ever used any of the following before?',
    field: 'everUsed',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'isNone', value: 'None', uncheckOthers: true },
        { key: 'patch', value: 'Birth control Patch' },
        { key: 'ring', value: 'Ring (NuvaRing)' },
        { key: 'injection', value: 'Injection / Shot / Depo-Provera' },
        { key: 'iud', value: 'IUD (Mirena and the like)' },
        { key: 'condoms', value: 'Condoms, Rhythm method, Withdrawal method' }
      ],
      fullWidth: true
    }
  },
  {
    // 3
    label: 'Have you ever experienced a migraine headache?',
    field: 'headache',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            label: 'Have you ever had one with an AURA?',
            type: 'radio',
            name: 'aura',
            options: [
              {
                key: 'yes',
                value: 'Yes',
                answer: { type: 'text', name: 'auraDesc' }
              },
              { key: 'no', value: 'No' }
            ]
          }
        },
        { key: 'no', value: 'No' }
      ],
      fullWidth: true
    }
  },
  {
    // 4
    label: 'Do you know the first day of your last menstrual period?',
    field: 'menstrual',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            label:
            'What is the date of the first day of your last menstrual period?',
            type: 'date',
            required: true,
            name: 'firstDay'
          }
        },
        {
          key: 'no',
          value: 'No',
          answer: {
            type: 'text',
            name: 'noReason',
            placeholder: 'Please explain'
          }
        }
      ],
      fullWidth: true
    }
  },
  {
    // 5
    label: 'Is there any possibility of you being pregnant?',
    field: 'pregnant',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yesDesc',
            placeholder: 'Please explain'
          }
        },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    // 6
    label: 'Have you given birth in the last 6 weeks?',
    field: 'givenBirth',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yesDesc',
            placeholder: 'Please explain'
          }
        },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    // 7
    label: 'Are you currently breastfeeding?',
    field: 'breastfeeding',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yesDesc',
            placeholder: 'Please explain'
          }
        },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    // 8
    label: 'What is your height?',
    field: 'height',
    type: 'info',
    answer: {
      type: 'measure-list',
      value1: {
        type: 'number',
        name: 'feet',
        placeholder: 'feet',
        size: 'large'
      },
      unit1: 'ft',
      value2: {
        type: 'number',
        name: 'inch',
        placeholder: 'inch',
        size: 'large'
      },
      unit2: 'in'
    }
  },
  {
    // 9
    label: 'What is your weight?',
    field: 'weight',
    type: 'info',
    answer: {
      type: 'measure',
      value: {
        type: 'number',
        name: 'value',
        placeholder: 'weight',
        size: 'large'
      },
      division: '&mdash;',
      unit: {
        type: 'dropdown',
        name: 'unit',
        options: [
          { key: 'lbs', value: 'lbs' },
          { key: 'kgs', value: 'kgs' }
        ],
        placeholder: 'unit',
        size: 'large'
      }
    }
  },
  {
    // 11
    label: 'Do you have any problems with your periods? ',
    field: 'periods',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'different',
          value: 'Abnormal vaginal bleeding different from my usual period,'
        },
        {
          key: 'morefrequent',
          value:
            'Periods have become more frequent or heavier than my usual period'
        },
        { key: 'between', value: 'Abnormal bleeding between your periods' },
        { key: 'other', value: 'Other' },
        { key: 'isNone', value: 'None', uncheckOthers: true }
      ],
      fullWidth: true
    }
  },
  {
    //12
    label: 'When was your last pelvic exam and Pap Smear?',
    field: 'pelvicexam',
    type: 'info',
    answer: {
      type: 'dropdown',
      name: 'lastexam',
      placeholder: 'Please select',
      options: [
        { key: 'less12m', value: 'Less than 12 months ago' },
        { key: '12to36m', value: '12 to 36 months ago' },
        { key: '3morey', value: 'More than 3 years ago' }
      ]
    }
  },
  {
    // 13
    label:
      'Have you had a breast exam performed by a clinician in the last 2 years?',
    field: 'breastexam',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            label: 'Was your exam normal?',
            type: 'radio',
            name: 'examNormal',
            options: [
              { key: 'yes', value: 'Yes, it was normal' },
              {
                key: 'no',
                value: 'No',
                answer: {
                  type: 'text',
                  name: 'noDesc',
                  placeholder: 'Please explain'
                }
              }
            ]
          }
        },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    // 14
    label:
      ' Have you ever had any sexually transmitted infections (Chlamydia, Gonorrhoea, Trichomonas, HIV)?',
    field: 'infections',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yesDesc',
            placeholder: 'Describe when and how you were tested and treated'
          }
        },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    // 15
    label: 'Do you have or have you had any of the following?',
    field: 'haveOrhad',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'cancer',
          value: 'Cancer',
          answer: {
            type: 'text',
            name: 'cancerDesc',
            placeholder: 'Please describe'
          }
        },
        {
          key: 'diabetes',
          value: 'Diabetes',
          answer: {
            type: 'text',
            name: 'diabetesDesc',
            placeholder: 'Please describe'
          }
        },
        {
          key: 'stroke',
          value: 'Stroke',
          answer: {
            type: 'text',
            name: 'strokeDesc',
            placeholder: 'Please describe'
          }
        },
        {
          key: 'heartAttack',
          value: 'Heart attack',
          answer: {
            type: 'text',
            name: 'heartAttackDesc',
            placeholder: 'Please describe'
          }
        },
        {
          key: 'liverProblems',
          value: 'Liver problems',
          answer: {
            type: 'text',
            name: 'liverProblemsDesc',
            placeholder: 'Please describe'
          }
        },
        {
          key: 'gallbladder',
          value: 'Gallbladder issues',
          answer: {
            type: 'text',
            name: 'gallbladderDesc',
            placeholder: 'Please describe'
          }
        },
        { key: 'isNone', value: 'None of above', uncheckOthers: true }
      ]
    }
  },
  {
    // 16
    label: 'Have you had any of the following blood clots related conditions?',
    field: 'bloodClots',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'bloodClotting',
          value: 'Blood clotting disorder',
          answer: {
            type: 'text',
            name: 'bloodClottingDesc',
            placeholder: 'Please describe'
          }
        },
        {
          key: 'clotlegs',
          value: 'a blood clot in the legs (Deep Vein Thrombosis - DVT)',
          answer: {
            type: 'text',
            name: 'clotlegsDesc',
            placeholder: 'Please describe'
          }
        },
        {
          key: 'clotlungs',
          value: 'a blood clot in your lungs (Pulmonary embolism - PE)',
          answer: {
            type: 'text',
            name: 'clotlungsDesc',
            placeholder: 'Please describe'
          }
        },
        { key: 'isNone', value: 'None of above', uncheckOthers: true }
      ]
    }
  },
  {
    // 17
    label: 'Do you currently smoke tobacco (cigarettes)?',
    field: 'cigarettes',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'cigaYes',
          value: 'Yes',
          answer: {
            type: 'list',
            items: [
              {
                label: 'How many cigarettes per day do you smoke on average',
                type: 'dropdown',
                name: 'cigaPerDay',
                options: [
                  { key: 'less5', value: 'Less than 5' },
                  { key: '6to10', value: '6-10' },
                  { key: '11to15', value: '11-15' },
                  { key: '16to20', value: '16-20' },
                  { key: '21to25', value: '21-25' },
                  { key: 'more25', value: 'more than 25' }
                ]
              },
              {
                label: 'How many years have you smoked for on a regular basis',
                type: 'dropdown',
                name: 'cigaYears',
                options: [
                  { key: 'less1', value: 'Less than 1 year' },
                  { key: '1to3', value: '1 to 3 years' },
                  { key: '4to9', value: '4 to 9 years' },
                  { key: 'more10', value: 'more than 10 years' }
                ]
              }
            ]
          }
        },
        { key: 'cigaNo', value: 'No' }
      ]
    }
  },
  {
    // 18
    label: 'Is there anything else you would like the medical team to know?',
    field: 'medicalTeam',
    type: 'info',
    answer: {
      type: 'text',
      placeholder: 'Please describe'
    }
  }
];

export default questionsModels;
